import { useInventoryColumnStore, L2CP_GROUP_ID, L2CP_COLUMN_IDS } from '@/stores';
import { createCrossDndProvider, stripSidebarPrefix, addSidebarPrefix } from '@/components/shared/createCrossDndProvider';
import type { CreateCrossDndProviderConfig } from '@/components/shared/createCrossDndProvider';

// eslint-disable-next-line react-refresh/only-export-components -- re-exporting utility helpers alongside the Provider; splitting would require updating ~6 import sites
export { stripSidebarPrefix, addSidebarPrefix };

const { Provider, useCrossDnd } = createCrossDndProvider({
  useColumnStore: useInventoryColumnStore as CreateCrossDndProviderConfig['useColumnStore'],
  tableScrollSelector: '[data-table-scroll-container]',
  displayName: 'CrossDndProvider',
  enableKeyboardSensor: true,
  l2cpConfig: {
    groupId: L2CP_GROUP_ID,
    columnIds: L2CP_COLUMN_IDS,
    sidebarPrefix: 'sidebar:l2cp:',
    tablePrefix: 'l2cp:',
  },
});

export const CrossDndProvider = Provider;
// eslint-disable-next-line react-refresh/only-export-components -- hook paired by design with the Provider above
export { useCrossDnd };
